import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Head, _FacebookPixel;
/** this app component should be used in the _app.tsx nextjs file */
import { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import NProgress from 'nprogress';
import { install } from '@crehana/devtools';
import { CrehanaLayout } from '@crehana/layouts';
import { CoursePreviewProvider, ProductsContainer, SavedCoursesProvider } from '@crehana/web';
import 'intersection-observer';
import { FacebookPixel } from "./components";
import { addExtraOptionsToFechApi } from "./utils/window-fetch";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
addExtraOptionsToFechApi();

/**
 * Expose the microfrontend name to the window object to make it easy to find the microfrontend of the current page
 */
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.CREHANA_MICROFRONTEND_NAME = process.env.CREHANA_MICROFRONTEND_NAME;
}
var MyApp = function MyApp(_ref) {
  var _pageProps$featureFla;
  var Component = _ref.Component,
    pageProps = _ref.pageProps,
    err = _ref.err,
    customRender = _ref.customRender;
  var router = useRouter();
  useEffect(function () {
    install();
  }, []);
  useEffect(function () {
    var handleStart = function handleStart() {
      NProgress.start();
    };
    var handleStop = function handleStop() {
      NProgress.done();
    };
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);
    return function () {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [_Head || (_Head = /*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=0"
      })
    })), /*#__PURE__*/_jsx("span", {
      className: "cui-is-visible cui-is-hidden",
      style: {
        opacity: 0,
        visibility: 'hidden',
        height: 0,
        width: 0,
        position: 'absolute'
      },
      "aria-hidden": true
    }), /*#__PURE__*/_jsxs(CrehanaLayout, {
      initialApolloState: pageProps.initialApolloState,
      countryCode: pageProps.countryCode,
      pageKey: pageProps.pageKey,
      i18nProviderProps: pageProps.i18nProviderProps,
      renderCookiesBanner: pageProps.renderCookiesBanner,
      isErrorPage: pageProps.isErrorPage,
      organizationSlug: pageProps.organizationSlug,
      children: [/*#__PURE__*/_jsx(CoursePreviewProvider, _objectSpread(_objectSpread({}, pageProps.coursePreviewProviderProps || {}), {}, {
        children: /*#__PURE__*/_jsx(SavedCoursesProvider, {
          children: !pageProps.disabledShoppingCart ? /*#__PURE__*/_jsx(ProductsContainer, {
            flagClassicShoppingCart: !!((_pageProps$featureFla = pageProps.featureFlags) !== null && _pageProps$featureFla !== void 0 && _pageProps$featureFla.classicShoppingCart),
            myCartQueryOptions: {
              skip: pageProps.isErrorPage
            },
            children: customRender ? customRender({
              Component: Component
            }) : /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
              err: err
            }))
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: customRender ? customRender({
              Component: Component
            }) : /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
              err: err
            }))
          })
        })
      })), _FacebookPixel || (_FacebookPixel = /*#__PURE__*/_jsx(FacebookPixel, {}))]
    }), /*#__PURE__*/_jsx(Script, {
      dangerouslySetInnerHTML: {
        __html: "window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config','".concat(process.env.NEXT_PUBLIC_GTAG_ID, "');")
      },
      strategy: "beforeInteractive"
    }), /*#__PURE__*/_jsx(Script, {
      dangerouslySetInnerHTML: {
        __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','".concat(process.env.NEXT_PUBLIC_GTM_ID, "')")
      },
      strategy: "afterInteractive"
    }), /*#__PURE__*/_jsx(Script, {
      src: "https://www.googletagmanager.com/gtag/js?id=".concat(process.env.NEXT_PUBLIC_GANALYTICS_ID),
      strategy: "afterInteractive"
    })]
  });
};
export default MyApp;